import _ from 'lodash';

export function joinArray(inputArray: any[], objectKey?: string): string {
  if(!inputArray || inputArray.length == 0) return '';
  if(!objectKey)
    return inputArray.join();
  return inputArray.map((item: any) => _.get(item, objectKey)).join();
}